module.exports = __webpack_public_path__ + "img/support_a6.46acc059.png";